/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { useState } from 'react';

/**
 * @returns {import('.').ViewModes}
 */
export default function useViewModes() {
  const VIEW_MODES = {
    VISUAL: 0,
    CODE: 1
  };
  const [view, setView] = useState(VIEW_MODES.VISUAL);

  const isVisualView = view === VIEW_MODES.VISUAL;
  const isCodeView = view === VIEW_MODES.CODE;

  return { view, setView, isVisualView, isCodeView };
}
